import {ROLES_KEY, SEMICOLON, USER_SIGN_TYPE} from "./constants";

//检查用户是否有操作会议的权限，false:无权限，true:有权限
export const checkOperateAuth = (meeting = {}, userInfo = {}) => {//创建者、主持人以及对应的会议室管理员都有权限修改
  const {userId, roleKey} = userInfo;
  if (!userId) return false;
  const {holdId, creatorId, roomAdmins = ""} = meeting;
  if (holdId === userId || creatorId === userId) {
    return true;
  }
  if (roleKey === ROLES_KEY.room_admin) {
    if (userId === roomAdmins
      || roomAdmins.startsWith(userId + SEMICOLON)
      || roomAdmins.endsWith(SEMICOLON + userId)
      || roomAdmins.indexOf(SEMICOLON + userId + SEMICOLON) !== -1) {
      return true;
    }
  }
  return false;
};
// NONE:0,//未签到
// PWD:1,//密码签到
// QR_CODE:2,//扫码签到
// FACE:3,//人脸识别签到
// INFRARED:4,//红外签到
// SUPPLEMENT_SIGN:5,//补签
// ANONYMOUS:6,//匿名签到
// DOOR_ACCESS:7,//门禁签到

// meeting_sing_type_none:'未签到',
// meeting_sing_type_pwd:'密码签到',
// meeting_sing_type_qr_code:'扫码签到',
// meeting_sing_type_face:'人脸识别签到',
// meeting_sing_type_infrared:'红外签到',
// meeting_sing_type_supplement:'预定人补签',
// meeting_sing_type_anonymous:'匿名签到',
// meeting_sing_type_door_access:'门禁签到',
export const convertNumToSignType = type => {
  let key = "";
  switch (type) {
    case USER_SIGN_TYPE.PWD:
      key = 'meeting_sing_type_pwd';
      break;
    case USER_SIGN_TYPE.QR_CODE:
      key = 'meeting_sing_type_qr_code';
      break;
    case USER_SIGN_TYPE.FACE:
      key = 'meeting_sing_type_face';
      break;
    case USER_SIGN_TYPE.INFRARED:
      key = 'meeting_sing_type_infrared';
      break;
    case USER_SIGN_TYPE.SUPPLEMENT_SIGN:
      key = 'meeting_sing_type_supplement';
      break;
    case USER_SIGN_TYPE.ANONYMOUS:
      key = 'meeting_sing_type_anonymous';
      break;
    case USER_SIGN_TYPE.DOOR_ACCESS:
      key = 'meeting_sing_type_door_access';
      break;
  }
  return key;

};
export const  getSignTypeKey = (key)=>{
  if(key == '-1'){
    return "service_sign_noneed";
  }else if(key == '1'){
    return "service_sign_password";
  }else if(key == '0'){
    return "service_sign_anonymous";
  }
  return "service_sign_noneed";
};



// WEBPACK FOOTER //
// ./src/utils/meetingUtil.js